// CORE
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

// OBSERVABLE
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

// MODEL
import {News} from '../model/news';
import {NewsPreview} from '../model/news_preview';
import { environment } from '../../environments/environment';


@Injectable()
export class HomepageService {

    constructor(private http: Http) {
        this.http = http;
    }

    getProfileData(user_id: number, course_id: number, key: string): Observable<any[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_Single_Lesson/profile_data/id_course/' + course_id + '/user_id/' + user_id, options)
            .map((response: Response) => <any[]>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getNewsPreview(course_id: number, key: string): Observable<NewsPreview> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_News/news_preview/id_course/' + course_id + '/', options)
            .map((response: Response) => <NewsPreview>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getSingleNews(course_id: number, news_id: number, key: string): Observable<News> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_News/single/id_course/' + course_id + '/id_news/' + news_id, options)
            .map((response: Response) => <News>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    getAllNews(course_id: number, key: string): Observable<News> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_News/all_news/id_course/' + course_id + '/', options)
            .map((response: Response) => <News>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

    searchNews(letter: string, course_id: number, key: string): Observable<News> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
        headers.append('X-API-KEY', key);
        const options = new RequestOptions({headers: headers});
        return this.http.get(environment.base_url + 'Rest_News/search/id_course/' + course_id + '/char/' + letter, options)
            .map((response: Response) => <News>response.json())
            .catch((error: any) => {
                return Observable.throw(error || error.json().error || 'Backend Server Error');
            });
    }

}





// WEBPACK FOOTER //
// ./src/app/services/homepage.service.ts